import IconWithFallback from 'src/components/icon-with-fallback';
import { Project } from 'src/redux/jira/types';

import * as styles from './jira-project-card.styled';

export const JiraProjectCard = ({ project }: { project: Project }) => (
  <styles.Item href={project.url} target="_blank">
    <IconWithFallback
      key={project.avatarUrls['48x48']}
      src={project.avatarUrls['48x48']}
      size="medium"
      appearance="square"
    />
    <styles.ProjectInfo>
      <styles.ProjectName>{project.name}</styles.ProjectName>
      <styles.SiteName>{project.site.cloudName}</styles.SiteName>
    </styles.ProjectInfo>
  </styles.Item>
);
